module.exports = __webpack_public_path__ + "img/svg-map.ca818fcd.svg";